import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { printQuotedmgc3s3pgfors as printQuoted } from './StringOps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonToStringWriterClass;
function JsonToStringWriter() {
  if (JsonToStringWriterClass === VOID) {
    class $ {
      constructor() {
        this.s2m_1 = StringBuilder().yb(128);
      }
      w2q(value) {
        this.s2m_1.zg(value);
      }
      q2q(char) {
        this.s2m_1.t1(char);
      }
      s2q(text) {
        this.s2m_1.r1(text);
      }
      c2r(text) {
        printQuoted(this.s2m_1, text);
      }
      t2m() {
        this.s2m_1.ch();
      }
      toString() {
        return this.s2m_1.toString();
      }
    }
    initMetadataForClass($, 'JsonToStringWriter', JsonToStringWriter);
    JsonToStringWriterClass = $;
  }
  return JsonToStringWriterClass;
}
//region block: exports
export {
  JsonToStringWriter as JsonToStringWriter25agxcyem0yhk,
};
//endregion

//# sourceMappingURL=JsonToStringWriterJsWasm.mjs.map
